import { render, staticRenderFns } from "./CounselForm.vue?vue&type=template&id=28d5bb55&scoped=true"
import script from "./CounselForm.vue?vue&type=script&lang=js"
export * from "./CounselForm.vue?vue&type=script&lang=js"
import style0 from "./CounselForm.vue?vue&type=style&index=0&id=28d5bb55&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d5bb55",
  null
  
)

export default component.exports